import React from "react";
import { node, shape, string, bool, func, instanceOf } from "prop-types";
import Popover from "react-popover";
import _get from "lodash/get";
import classNames from "classnames";

import ThemeConsumer from "../ThemeConsumer";

const ContextMenu = ({
  theme,
  children,
  container,
  trigger,
  menu,
  user,
  itemsTheme,
  customTheme,
  ...rest
}) => {
  theme = {
    ...theme,
    ...customTheme,
  };

  const getCustomTheme = (name) => {
    return _get(theme, _get(customTheme, name), "");
  };

  const wrapperTheme = classNames({
    [getCustomTheme("wrapper")]: getCustomTheme("wrapper"),
    [theme.wrapper]: !getCustomTheme("wrapper"),
  });

  const listTheme = classNames({
    [theme.user]: user,
    [theme.items]: !getCustomTheme("items"),
    [getCustomTheme("items")]: getCustomTheme("items"),
  });

  const contentTheme = classNames({
    [theme.themeMenu]: menu,
    [theme.normal]: !getCustomTheme("content"),
    [getCustomTheme("content")]: getCustomTheme("content"),
  });

  const popoverTheme = classNames({
    [theme.popover]: !getCustomTheme("popover"),
    [getCustomTheme("popover")]: getCustomTheme("popover"),
  });

  // TODO: Refatorar escolha de classes CSS de forma que não seja necessário
  // injetar prop menu e user. (ex: preset="menu")
  const content = (
    <div className={wrapperTheme}>
      <div className={contentTheme}>
        <ul className={listTheme}>
          {React.Children.map(children, (child) => {
            if (child) {
              return <li>{child}</li>;
            }
          })}
        </ul>
      </div>
    </div>
  );

  return (
    <Popover className={popoverTheme} body={content} {...rest}>
      {trigger}
    </Popover>
  );
};

ContextMenu.propTypes = {
  children: node.isRequired,
  theme: shape({
    normal: string,
  }),
  isOpen: bool,
  preferPlace: string,
  place: string,
  onOuterAction: func,
  container: instanceOf(Element),
  trigger: node.isRequired,
  menu: bool,
  user: bool,
  itemsTheme: string,
};

ContextMenu.defaultProps = {
  theme: {},
  isOpen: false,
  preferPlace: null,
  place: null,
  onOuterAction: null,
  container: null,
  menu: false,
  user: false,
};

export default ThemeConsumer("UIContextMenu")(ContextMenu);



// WEBPACK FOOTER //
// ./src/shared/components/ContextMenu/index.js